/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 积分商城兑换时增加成长值以及印花
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  pointsMallRedemptionReq: member.PointsMallRedemptionReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/points-mall/redemption`,
    data: pointsMallRedemptionReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
